import { jsx as s } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import c from "./ApplicationLayoutHeader.js";
import f from "./ApplicationLayoutSidebar.js";
import l from "./ApplicationLayoutBody.js";
import { initDocumentBootstrapping as d } from "../../utils/init/initDocumentBootstrapping.js";
import u from "../../utils/classNames.js";
d();
const o = n((r, t) => {
  const { className: a, layoutRef: i, children: p, ...e } = r, m = u("ApplicationLayout", a);
  return /* @__PURE__ */ s("div", { ...e, ref: t || i, className: m, children: p });
});
o.Header = c;
o.Sidebar = f;
o.Body = l;
export {
  o as default
};
//# sourceMappingURL=ApplicationLayout.js.map
